module.exports = __webpack_public_path__ + "img/ปลาไหล.634bdc2c.jpg";